
import { Component, Prop, Vue } from 'vue-property-decorator';
import { EliotModule } from '~/store/modules/eliot';

@Component
export default class Topology extends Vue {

    @Prop({default: ''}) readonly plantId!: string;

    get currentPlantNodes() {
        return EliotModule.currentPlantNodes;
    }

    get plantName() {
        return EliotModule.currentPlant?.name;
    }
}
